import logoSantaRita from '../assets/logos/logoSantaRita.png';
import logoBarraBonita from '../assets/logos/logoBarraBonita.png';
import logoCosmopolis from '../assets/logos/logoCosmopolis.png';
import logoSantaHelena from '../assets/logos/logoSantaHelena.png';
import logoMorroAgudo from '../assets/logos/logoMorroAgudo.png';
import Pongeluppe from '../assets/logos/logoPongeluppe.png';
import logoNovaEuropa from '../assets/logos/logoNovaEuropa.jpg';

const Logos = {
    "111111"  : Pongeluppe, 
    "222222"  : logoNovaEuropa, 
    "2127881" : Pongeluppe,  
    "9639659" : logoCosmopolis, 
    "2091267" : logoSantaRita, 
    "2790653" : Pongeluppe, 
    "2747693" : Pongeluppe, 
    "2745801" : logoMorroAgudo, 
    "2082632" : logoBarraBonita, 
    "5288541" : logoSantaHelena, 
    "2127695" : Pongeluppe,
    "2081717" : Pongeluppe,
    "2747685" : logoNovaEuropa,
}

export default Logos;